import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { Dialog } from '@material-ui/core';
import TrustApprovalContent from 'Components/Modals/TrustApproval/TrustApprovalContent';
import closeModal from 'Helpers/ModalHelper';
import { CollectionProvider } from 'Context/CollectionContext';

function TrustApprovalModal({
  classes, approvalLink, ...rest
}) {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Trust Approval Modal',
  });

  return (
    <Dialog
      {...rootNodeProps}
      onClose={() => {
        closeModal();
      }}
      open
    >
      <CollectionProvider link={approvalLink}>
        <TrustApprovalContent
          {...rest}
          onClose={() => {
            closeModal();
          }}
        />
      </CollectionProvider>
    </Dialog>
  );
}

TrustApprovalModal.propTypes = {
  classes: PropTypes.object.isRequired,
  uploadRelationship: PropTypes.string.isRequired,
  fileOptionListRelationship: PropTypes.string.isRequired,
};

export default withStyles(() => ({
  root: {
    marginTop: 0,
    height: '50%',
    width: '100%',
  },
  dialogContent: {
    marginTop: 0,
    height: '100%',
    width: '100%',
    transform: 'none',
    top: 'unset',
    left: 'unset',
    position: 'inherit',
  },
}))(TrustApprovalModal);
